import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import CardImage from "./CardImage";

interface CardImageModalProps {
  cardName: string | null;
  isOpen: boolean;
  onClose: (open: boolean) => void;
}

function CardImageModal({ cardName, isOpen, onClose }: CardImageModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="image-modal-dialog max-w-xs sm:max-w-sm lg:max-w-md p-0 bg-transparent border-none shadow-none">
        <DialogHeader className="sr-only">
          <DialogTitle>{cardName || "Tarot Card"}</DialogTitle>
        </DialogHeader>

        <div className="image-modal-container flex flex-col items-center space-y-4">
          {/* Large card image */}
          <div className="modal-card-image bg-white rounded-lg p-2 shadow-2xl">
            <CardImage
              cardName={cardName}
              className="w-full h-auto max-w-56 sm:max-w-64 lg:max-w-72 mx-auto rounded-lg"
              alt={`${cardName} - Full size view`}
              showPlaceholder={false}
            />
          </div>

          {/* Card name below image */}
          {cardName && (
            <div className="modal-card-info text-center">
              <h3 className="modal-card-name text-white text-lg sm:text-xl font-medium bg-black/50 px-4 py-2 rounded-lg backdrop-blur-sm">
                {cardName}
              </h3>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CardImageModal;
